import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;
export const getOfficeHierarchy = async () => {
  const data = await axios.get(`${api_base_url}/OfficeHierarchy`);
  return data;
};

export const getOfficeHierarchies = async () => {
  return await axios
    .get(`${api_base_url}/OfficeHierarchy/OfficeHierarchy`)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        return [];
      }
    });
};
export const getOfficeHierarchyByTypeId = async (type, id) => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/OfficeHierarchy/${type},${id}`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeHierarchyChildByTypeId = async (type, id) => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/OfficeHierarchyChild/${type},${id}`)
    .then((res) => {
      return res.data;
    });
};
export const addOfficeHierarchy = async (newHierarchy) => {
  const data = {
    Name: newHierarchy.name,
    IdC: newHierarchy.idc,
    Code: newHierarchy.code,
    AreaCode: newHierarchy.hiddenAreaCode,
    HierarchyCode: newHierarchy.officeHierarchyCode,
    EmployeeId: newHierarchy.employeeId,
    IsActive: "True",
    IsFranchise: newHierarchy.isFranchise,
    Manager: null,
    ManagerEmpId: newHierarchy.managerEmpId,
    ManagerEffectiveDate: newHierarchy.managerEmployeeDate,
    EffectiveDate: newHierarchy.managerEffectiveDate,
    ManagerEmail: newHierarchy.managerEmail,
    ManagerName: newHierarchy.manager,
    ParentHierarchy: newHierarchy.parentHierarchy,
    ParentHierarchyId: newHierarchy.parentHierarchyId,
    PreviousManagerId: newHierarchy.previousManagerId,
    RegionMarketLeader: newHierarchy.hiddenRegionMarketLeader,
    RegionCode: newHierarchy.hiddenRegionCode,
    SalesPresident: newHierarchy.salesPresident,
    SalesVp: newHierarchy.salesVp,
    TerritoryCode: newHierarchy.hiddenTerritoryCode,
    DistrictId: newHierarchy.districtId,
    DistrictCode: newHierarchy.hiddenDistrictCode,
    Type: newHierarchy.type,
    Description: newHierarchy.description,
    BaseUrl: window.location.origin,
    ManagerEmployeeId:
      newHierarchy.managerEmployeeId === ""
        ? 0
        : newHierarchy.managerEmployeeId,
  };

  return await axios.post(`${api_base_url}/OfficeHierarchy`, {
    ...data,
  });
};
export const editOfficeHierarchy = async (oh) => {
  const data = {
    Idc: oh.idC,
    Id: oh.officeHierarchyId,
    Code: oh.code,
    Name: oh.name,
    ManagerEmpId: oh.managerEmpId,
    ParentHierarchyId: oh.parentHierarchyId,
    Type: oh.type,
    Description: oh.description,
    EffectiveDate:
      oh.managerEffectiveDate === "" ? null : oh.managerEffectiveDate,
    IsActive: oh.isActive,
    BaseUrl: window.location.origin,
    ManagerEmployeeId: oh.managerEmployeeId === null ? 0 : oh.managerEmployeeId,
    IsFranchise: oh.isFranchise,
    PreviousManagerId: oh.PreviousManagerId,
  };

  return await axios.put(`${api_base_url}/OfficeHierarchy`, {
    ...data,
  });
};
export const deleteOfficeHierarchy = async (ids) => {
  return await axios.delete(`${api_base_url}/OfficeHierarchy`, {
    data: ids,
  });
};

export const getHierarchyActivityById = async (officeHierarchyId) => {
  let hierarchyActivityLogsData;
  await axios
    .get(
      `${api_base_url}/OfficeHierarchy/GetHierarchyActivityById/${officeHierarchyId}`
    )
    .then((res) => (hierarchyActivityLogsData = res.data));
  return hierarchyActivityLogsData;
};

export const getOfficeHierarchyById = async (id) => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/GetOfficeHierarchyById/${id}`)
    .then((res) => {
      return res.data;
    });
};

export const getParentOfficeHierarchy = async (code, isParent = false) => {
  return axios
    .get(
      `${api_base_url}/OfficeHierarchy/GetParentOfficeHierarchyByCode/${code}/${isParent}`
    )
    .then((res) => {
      return res.data;
    });
};

export const getOfficeHierarchyManager = async () => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/GetManagers/`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeHierarchyCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/HierarchyGetCount/`)
    .then((res) => {
      return res.data;
    });
};
